import React from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import "../index.css";

function Home() {
  return (
      
        <main id="home">
            <Header />

            {/* Introduction */}
            <section className="intro">
                <h1 className="section__title section__title--intro">
                    Hi, I'm <strong>Elmer Gomez</strong>
                </h1>
                <p className="section__subtitle section__subtitle--intro">Front-End Web Developer</p>
                <img className="intro__img img__profile" src={process.env.PUBLIC_URL + "/images/elmer-gomez.jpeg"} alt="Elmer Gomez smiling" />
            </section>

            {/* My Skills */}
            <section className="my-services" id="services">

                <h2 className="section__title section__title--services">What I do</h2>
                <div className="services">
                    <div className="service service-1">
                        <img className="img__icon" src={process.env.PUBLIC_URL + "/images/design-devt.jpg"} alt="" />
                        <h3>Design + Development</h3>
                        <p>I strive to blend the best of both 
                            worlds: efficient functionality and beautiful design. Writing clean code and creating 
                            effective UI/UX are integral to my job as a front-end developer.
                        </p>
                    </div> {/* / service */}
                    
                    <div className="service service-2">
                        <img className="img__icon" src={process.env.PUBLIC_URL + "/images/e-commerce.jpg"} alt="" />
                        <h3>E-Commerce</h3>
                        <p>I have practical experience with e-commerce and have developed projects from the ground up. 
                        I create online stores that are not only good to look at, but are efficient under the hood.
                        </p>
                    </div> {/* / service */}
                    
                    <div className="service service-3">
                        <img className="img__icon" src={process.env.PUBLIC_URL + "/images/wordpress-shopify.jpg"} alt="" />
                        <h3>WordPress + Shopify</h3>
                        <p>Currently, I utilize the WordPress CMS to 
                            quickly develop professional-looking websites and the Shopify platform to develop a complete solution for an online store.
                        </p>
                    </div> {/* / service */}
                </div> {/* / services */}
                <div className="services__skills"><span className="services__skills--text">Technologies I currently use: WordPress, Shopify Liquid, HTML+CSS+Javascript, React, Bootstrap, jQuery</span></div>
                <div className="services__skills"><span className="services__skills--text">Other technologies I used in the past: Drupal, Joomla, PHP, SQL, ASP</span></div>

                <a href="#work" className="btn">My work</a>
            </section>
            
            /* About me */
                        <section className="about-me" id="about">
                        <h2 className="section__title section__title--about">Who I am</h2>
                        <p className="section__subtitle section__subtitle--about">Designer & developer based in Quezon City PH</p>
                        
                        <div className="about-me__body">
                            <p>I am a web developer who builds websites from the ground up — from structure and design to performance and search visibility.</p>
                            <p>Before becoming a developer, I worked as a graphic designer. This background informs how I approach the web: combining visual clarity with clean, functional code.</p>
                            <p>Earlier in my career, I served as a technology officer in a government agency where I managed websites and internal systems. During that time, I worked with open-source CMS platforms such as Drupal and Joomla to develop and maintain web applications and databases.</p>
                            <p>After becoming an independent developer, my work focused primarily on building and optimizing websites using WordPress and modern web technologies.</p>
                            <p>Alongside development, I specialize in search optimization. Every website and article I produce is structured with SEO in mind — including keyword research, content architecture, technical performance, and search indexing.</p>
                            <p>My long-standing interest in books and literary culture also led me to found <a href="https://bookishbay.com" target="_blank" rel="noreferrer">BookishBay.com</a>, a publication where I apply both development and SEO strategies to build and grow a content-driven website.</p>
                        </div>
                        
                        <img src={process.env.PUBLIC_URL + "/images/elmer-gomez-half-body.jpg"} alt="Elmer Gomez standing in front of murals" className="about-me__img" />
                        </section>

                        {/* My recent projects */}
            <section className="my-work" id="work">
                <h2 className="section__title">My recent projects</h2>
                <p className="section__subtitle section__subtitle--work">A selection of my range of work</p>
                <div className="portfolio">
                    {/* Portfolio item 01 */}
                    <Link to="/printamerch" className="portfolio__item">
                        <img src={process.env.PUBLIC_URL + "/images/portfolio-01.jpg"} alt="" className="portfolio__img" />
                    </Link>
                    
                    {/* Portfolio item 02 */}
                    <Link to="/bookishbay" className="portfolio__item">
                        <img src={process.env.PUBLIC_URL + "/images/portfolio-02.jpg"} alt="" className="portfolio__img" />
                    </Link>
                    
                    {/* Portfolio item 03 */}
                    <Link to="/downloadtoprint" className="portfolio__item">
                        <img src={process.env.PUBLIC_URL + "/images/portfolio-03.jpg"} alt="" className="portfolio__img" />
                    </Link>
                </div>
                <div className="label-tag">
                    <Link to="/moreprojects" className="label-tag__link">See more projects</Link>&nbsp;&nbsp;<i className="fas fa-arrow-right"></i>
                </div>
            </section>    

            <Footer />

        </main>
       
  );
}

export default Home;